export const siteInfo = {
  name: 'Stirret Schools',
  tagline: 'Raising Exceptional Leaders',
  description: 'Premium Montessori, Primary, and Secondary education in Nigeria',
  contact: {
    phone: '08145723982',
    email: 'info@stirretschools.com',
    address: '2-6 Ewenla St, Ojokoro 112105, Ogun State',
  },
  social: {
    instagram: 'https://instagram.com/stirretschools',
    facebook: 'https://facebook.com/stirretschools',
    twitter: 'https://twitter.com/stirretschools',
    linkedin: 'https://linkedin.com/company/stirretschools',
  },
};

export const schoolDivisions = {
  montessori: {
    name: 'Stirret Montessori Nursery & Primary School',
    shortName: 'Montessori & Primary',
    tagline: 'Nurturing Curiosity, Building Foundations',
    ageRange: 'Ages 2-11',
    description: 'Our Montessori approach nurtures natural curiosity and builds strong foundations for lifelong learning.',
    color: 'emerald',
    href: '/montessori',
    features: [
      'Child-centered learning',
      'EYFS curriculum',
      'Small class sizes',
      'Experienced educators',
    ],
  },
  college: {
    name: 'Stirret College',
    shortName: 'College',
    tagline: 'Excellence in Education, Leaders in Life',
    ageRange: 'Ages 11-18',
    description: 'Academic excellence combined with holistic development prepares students for global success.',
    color: 'primary',
    href: '/college',
    features: [
      'Cambridge curriculum',
      'WAEC/NECO preparation',
      'University placement support',
      'Leadership programs',
    ],
  },
};

export const statistics = [
  { value: '1000+', label: 'Students', icon: 'Users' },
  { value: '95%', label: 'University Placement', icon: 'GraduationCap' },
  { value: '9+', label: 'Years of Excellence', icon: 'Award' },
  { value: '50+', label: 'Expert Educators', icon: 'BookOpen' },
];

export const features = [
  {
    title: 'World-Class Facilities',
    description: 'State-of-the-art laboratories, libraries, and sports facilities designed for optimal learning.',
    icon: 'Building2',
  },
  {
    title: 'Expert Educators',
    description: 'Highly qualified teachers passionate about nurturing each child\'s unique potential.',
    icon: 'Users',
  },
  {
    title: 'Holistic Development',
    description: 'Balance of academics, arts, sports, and character development for well-rounded growth.',
    icon: 'Heart',
  },
  {
    title: 'Safe Environment',
    description: 'Secure campus with modern safety measures ensuring peace of mind for parents.',
    icon: 'Shield',
  },
  {
    title: 'Technology Integration',
    description: 'Modern learning tools and digital literacy programs preparing students for the future.',
    icon: 'Laptop',
  },
  {
    title: 'Global Standards',
    description: 'International curriculum standards meeting global educational benchmarks.',
    icon: 'Globe',
  },
];

export const navigation = {
  main: [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/about' },
    {
      label: 'Our Schools',
      href: '/our-schools',
      children: [
        {
          title: 'Montessori & Primary',
          subtitle: 'Ages 2-11',
          description: 'Child-centered learning in a nurturing environment',
          href: '/montessori',
          links: [
            { label: 'Overview', href: '/montessori' },
            { label: 'Curriculum', href: '/montessori/curriculum' },
            { label: 'Facilities', href: '/montessori/facilities' },
            { label: 'Gallery', href: '/montessori/gallery' },
          ],
        },
        {
          title: 'Stirret College',
          subtitle: 'Ages 11-18',
          description: 'Academic excellence meets holistic development',
          href: '/college',
          links: [
            { label: 'Overview', href: '/college' },
            { label: 'Academics', href: '/college/academics' },
            { label: 'Extracurriculars', href: '/college/extracurriculars' },
            { label: 'Achievements', href: '/college/achievements' },
          ],
        },
      ],
    },
    { label: 'Admissions', href: '/admissions' },
    { label: 'Gallery', href: '/gallery' },
    { label: 'News', href: '/news' },
    { label: 'Contact', href: '/contact' },
  ],
};
